import { Cross2Icon } from '@radix-ui/react-icons';
import { Button, Dialog, Tabs } from '@radix-ui/themes';
import classNames from 'classnames';
import type { FollowerUserType } from 'types/user';
import PlayerUserObject from './PlayerUserObject';

export const FollowNetworkBox: React.FC<{
  followers?: FollowerUserType[];
  following?: FollowerUserType[];
  followersDefault: boolean;
  name?: string;
}> = ({ followers, following, followersDefault, name }) => (
  <div id='seeList'>
    <Dialog.Root>
      <Dialog.Trigger>
        <Button size='2' variant='outline' className='cursor-pointer text-nowrap'>
          Vedi lista
        </Button>
      </Dialog.Trigger>
      <Dialog.Content className='max-w-96 p-3 md:max-w-md'>
        <div className='flex w-full justify-between align-middle'>
          {name ? <Dialog.Title>Rete di {name}</Dialog.Title> : <Dialog.Title>Lista</Dialog.Title>}
          <Dialog.Close className='mb-4 cursor-pointer'>
            <Cross2Icon height={'24'} width={'24'} />
          </Dialog.Close>
        </div>
        <Dialog.Description className='hidden'>Lista dei followers di {name}</Dialog.Description>
        <div
          id='container'
          className='flex max-w-80 grow-0 basis-80 flex-col items-start gap-4 rounded-xl md:max-w-96 md:basis-96 md:p-3'
        >
          <Tabs.Root className='w-full' defaultValue={followersDefault ? 'followers' : 'following'}>
            <Tabs.List className={classNames('justify-center', { hidden: !following })}>
              <Tabs.Trigger value='followers'>Followers</Tabs.Trigger>
              <Tabs.Trigger value='following'>Seguiti</Tabs.Trigger>
            </Tabs.List>

            <Tabs.Content value='followers'>
              <div id='players' className='flex flex-col items-start gap-4 self-stretch'>
                {followers?.map((player) => <PlayerUserObject showRole={true} key={player.id} {...player} />)}
              </div>
            </Tabs.Content>

            <Tabs.Content value='following'>
              <div id='players' className='flex flex-col items-start gap-4 self-stretch'>
                {following?.map((player) => <PlayerUserObject showRole={true} key={player.id} {...player} />)}
              </div>
            </Tabs.Content>
          </Tabs.Root>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  </div>
);

export default FollowNetworkBox;
